import { Sensor, useSensorAlerts, AlertStatus } from 'common';
import { useMemo } from 'react';

/**
 * Hook to determine if HVAC filter alert card should be shown
 * Based on the presence of unacknowledged HVAC_FILTER alerts
 */
export const useHVACFilterAlertVisibility = (sensor?: Sensor): boolean => {
  const { sensorAlerts } = useSensorAlerts(sensor?.id);

  const shouldShowAlert = useMemo(() => {
    if (!sensor?.id || !sensorAlerts.length) {
      console.log('WEB DEBUG AlertVisibility: No sensor or alerts', {
        sensorId: sensor?.id,
        alertCount: sensorAlerts.length,
      });
      return false;
    }

    console.log('WEB DEBUG AlertVisibility: All alerts for sensor', sensor.id, sensorAlerts);

    const hvacFilterAlerts = sensorAlerts.filter((alert) => {
      const isHVACFilterAlert = alert.alertType === 'HVAC_FILTER';
      // Support both firmware statuses and actual system statuses
      const isActiveStatus =
        alert.status === AlertStatus.PENDING ||
        alert.status === AlertStatus.ACTIVE ||
        alert.status === 'new' ||
        alert.status === 'ongoing';
      const isUnacknowledged = !alert.acknowledgedAt && !alert.acknowledgedBy;

      console.log('WEB DEBUG AlertVisibility: Alert filter check', {
        alertId: alert.id,
        alertType: alert.alertType,
        status: alert.status,
        isHVACFilterAlert,
        isActiveStatus,
        isUnacknowledged,
        acknowledgedAt: alert.acknowledgedAt,
        acknowledgedBy: alert.acknowledgedBy,
      });

      return isHVACFilterAlert && isActiveStatus && isUnacknowledged;
    });

    console.log('WEB DEBUG AlertVisibility: Filtered HVAC alerts', hvacFilterAlerts);
    return hvacFilterAlerts.length > 0;
  }, [sensor?.id, sensorAlerts]);

  return shouldShowAlert;
};
